import { inject } from "@angular/core";
import { CustomIconService } from "../services/custom-icon.service";

/**
 * Initializes the custom icons
 */
export const iconsInit = async (): Promise<boolean> => {
  const iconsService = inject(CustomIconService);

  await iconsService.addCustomIcons();
  return true;
};
